import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VChip,{staticClass:"mx-1",attrs:{"small":"","color":_vm.color,"text-color":"white"}},[_vm._v(" "+_vm._s(_vm.complex)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }